import type { FlightIngredient } from '@apps/main/modules/recipe/ingredients';
import type { FerryIngredient } from '@apps/main/modules/recipe/ingredients/ferryIngredient';

import { IngredientType } from '@libs/trip-planner-interfaces';
import type {
  FlightIngredientAdapter,
  FerryIngredientAdapter,
} from '@libs/trip-planner-interfaces';
import { assertValue } from '@libs/utils';

export function adaptFlightIngredientToItinerarySearchCriteria(
  flightIngredient: FlightIngredient
): FlightIngredientAdapter {
  if (!flightIngredient.isIngredientCorrect()) {
    throw new Error(
      'Impossible code path reached! FlightIngredient should always have from and to!'
    );
  }

  assertValue(
    flightIngredient.fromPort,
    'transportIngredientItinerarySearchAdapter > adaptFlightIngredientToItinerarySearchCriteria > fromPort'
  );
  assertValue(
    flightIngredient.toPort,
    'transportIngredientItinerarySearchAdapter > adaptFlightIngredientToItinerarySearchCriteria > toPort'
  );

  return {
    ingredientType: IngredientType.Flight,
    ingredientId: flightIngredient.ingredientId,
    fromPort: flightIngredient.fromPort,
    toPort: flightIngredient.toPort,
    transportIds: flightIngredient.transportIds,
    maxNumberOfStops: flightIngredient.filters.maxNumberOfStops,
    departureTimeFilters: flightIngredient.filters.departureTimeFilters,
    arrivalTimeFilters: flightIngredient.filters.arrivalTimeFilters,
    maxDurationInHours: flightIngredient.filters.maxDurationInHours,
    priceFilters: flightIngredient.filters.priceFilters,
    carrierFilters: flightIngredient.filters.carrierFilters,
    suggestedBy: flightIngredient.availabilityOrder,
  };
}

export function adaptFerryIngredientToItinerarySearchCriteria(
  ferryIngredient: FerryIngredient
): FerryIngredientAdapter {
  if (!ferryIngredient.isIngredientCorrect()) {
    throw new Error(
      'Impossible code path reached! FerryIngredient should always have from and to!'
    );
  }

  assertValue(
    ferryIngredient.fromPort,
    'transportIngredientItinerarySearchAdapter > adaptFerryIngredientToItinerarySearchCriteria > fromPort'
  );
  assertValue(
    ferryIngredient.toPort,
    'transportIngredientItinerarySearchAdapter > adaptFerryIngredientToItinerarySearchCriteria > toPort'
  );

  return {
    ingredientType: IngredientType.Ferry,
    ingredientId: ferryIngredient.ingredientId,
    fromPort: ferryIngredient.fromPort,
    toPort: ferryIngredient.toPort,
    transportIds: ferryIngredient.transportIds,
    departureTimeFilters: ferryIngredient.filters.departureTimeFilters,
    arrivalTimeFilters: ferryIngredient.filters.arrivalTimeFilters,
    maxDurationInHours: ferryIngredient.filters.maxDurationInHours,
    priceFilters: ferryIngredient.filters.priceFilters,
    carrierFilters: ferryIngredient.filters.carrierFilters,
    vehicles: ferryIngredient.vehicles,
    suggestedBy: ferryIngredient.availabilityOrder,
  };
}
